import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import intl from "react-intl-universal";

import * as actions from "../../actions";

class OrderInvite extends Component {
  render() {
    let { hostName, joinLink, restaurantName, inviteId } = this.props.message;
    
    let content = intl
      .getHTML("orderInvite.content", { restaurantName, hostName });

    return (
      <div className="order-invite">
        <div className="order-invite__content">{content}</div>
        <div className="order-invite__buttons">
          <button onClick={() => {
              this.props.acceptOrderInvite(
                { inviteId, customerId: this.props.customerId },
                res => {
                  if (res.success === false) {
                    toast.error(
                      intl.get("orderInvite.error.acceptOrderInvite")
                    )
                  } else {
                    window.location.replace(joinLink)
                  }
                }
              );
              }}>
            {intl.get("orderInvite.button.accept")}
          </button>
          <button
            onClick={() => {
              this.props.ignoreOrderInvite(
                { inviteId, customerId: this.props.customerId },
                res => {
                 
                  if (res.success === false) {
                    toast.error(
                      intl.get("orderInvite.error.ignoreOrderInvite")
                    );
                  }
                }
              );
            }}
          >
            {intl.get("orderInvite.button.ignore")}
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    customerId: auth.profile.customer.id
  };
}

export default connect(
  mapStateToProps,
  actions
)(OrderInvite);
